module.exports = __webpack_public_path__ + "img/update.81757f0b.png";